














































































































import {
  defineComponent,
  onBeforeMount,
  reactive,
  SetupContext,
  watch,
  computed,
} from '@vue/composition-api';
import EntityDialog from '@/components/common/EntityDialog.vue';
import { ProductCategoryOption } from '@/models/entities/ProductCategoryOption';

interface Props {
  id: string;
}

interface State {
  entity: ProductCategoryOption;
  loading: boolean;
}

const Component = defineComponent({
  name: 'ProductCategoryOptionsDialog',

  components: {
    EntityDialog,
  },

  props: {
    id: String,
  },

  setup(props: Props, { root: { $store, $router } }: SetupContext) {
    let productCategoryOption = new ProductCategoryOption({});

    let isNew = () => !props.id;

    onBeforeMount(async () => {
      if (!isNew()) {
        const res = await $store.dispatch(
          `productCategoryOptionsModule/fetchItem`,
          props.id,
        );
        if (!res) $router.back();
      }
    });

    const state = reactive({
      entity: productCategoryOption,
      loading: computed(() => $store.getters['productCategoryOptionsModule/loading']),
    }) as State;

    watch(
      () => $store.getters['productCategoryOptionsModule/selectedItem'],
      (newValue: ProductCategoryOption) => Object.assign(productCategoryOption, newValue),
      { immediate: false, deep: true },
    );

    const title = computed(() => {
      if (state.loading) return '';
      if (isNew()) return 'New Product Category Option';
      return `Edit Product Category Option`;
    });

    const rules = {
      title: [(v: string) => !!v || 'Title is required'],
      number: [(v: number) => v >= 0 || 'Only positive numbers allowed'],
    };

    return {
      state,
      title,
      rules,
      isNew,
    };
  },
});
export default Component;
